export const expectedQuotesConstants = {
  GET_EXPECTED_QUOTES_REQUEST: 'GET_EXPECTED_QUOTES_REQUEST',
  GET_EXPECTED_QUOTES_SUCCESS: 'GET_EXPECTED_QUOTES_SUCCESS',
  GET_EXPECTED_QUOTES_FAILURE: 'GET_EXPECTED_QUOTES_FAILURE',
  UPDATE_EXPECTED_QUOTES_COMMENTS: 'UPDATE_EXPECTED_QUOTES_COMMENTS',
};
